export {}

const initCheckboxSelect = () => {

  const selectsSelector = ".f-checkbox-select"
  const selects = document.querySelectorAll(selectsSelector)

  const closeAll = () => selects.forEach((select) => select.classList.remove("--active"))

  // Handle click outside
  if (selects.length) {
    document.addEventListener("click", ({target}) => {
      if (target instanceof Element && !target.closest(selectsSelector)) {
        closeAll()
      }
    })
  }

  selects.forEach((select) => {
    const toggler = select.querySelector<HTMLElement>(".f-checkbox-select__toggler")
    const title = select.querySelector<HTMLElement>(".f-checkbox-select__title")
    const clearButton = select.querySelector<HTMLElement>(".f-checkbox-select__clear")
    const count = clearButton?.querySelector<HTMLElement>(".i-tag__title")

    const checkboxes = select.querySelectorAll<HTMLInputElement>("input[type=checkbox]")

    const open = () => {
      closeAll()
      select.classList.add("--active")
    }

    const toggleHandle = () => (select.classList.contains("--active") ? closeAll() : open())

    toggler?.addEventListener("click", toggleHandle)
    title?.addEventListener("click", toggleHandle)

    const getCheckedCheckboxes = () => [...checkboxes].filter((checkbox) => checkbox.checked)

    const getCheckedCount = () => getCheckedCheckboxes().length

    const uncheckAll = () => {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event("change"))
      })
    }

    const handleActivate = () => {
      clearButton?.classList.add("--active")
    }

    const handleDeactivate = () => {
      if (getCheckedCount() <= 0) {
        clearButton?.classList.remove("--active")
      }
    }

    clearButton?.addEventListener("click", () => {
      clearButton.classList.remove("--active")
      uncheckAll()
    })

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        if (count) count.innerHTML = String(getCheckedCount())

        checkbox.checked ? handleActivate() : handleDeactivate()
      })
    })
  })
}

initCheckboxSelect()
document.addEventListener("checkboxSelectReinit", initCheckboxSelect)
